import { useQuery } from "@tanstack/react-query";
import { getMenuCategories } from "../../../../store/Menu/api";

export const useGetCategories = ({ slug, filters }) => {
    const validatedValues = Object.assign({}, filters)
    if(!validatedValues.term) {
        delete validatedValues.term
    }
    return useQuery(["menu-categories", slug, filters.status, filters.term], () => getMenuCategories({ slug, filters: validatedValues }));
};
